import * as prismic from "@prismicio/client";
const readValue = (value) => {
  return value.replace(/%3B/g, ";");
};
const getPrismicPreviewCookie = (cookieJar) => {
  const cookies = cookieJar.split("; ");
  let value;
  for (const cookie of cookies) {
    const parts = cookie.split("=");
    const name = readValue(parts[0]).replace(/%3D/g, "=");
    if (name === prismic.cookie.preview) {
      value = readValue(parts.slice(1).join("="));
      continue;
    }
  }
  return value;
};
export {
  getPrismicPreviewCookie
};
//# sourceMappingURL=getPrismicPreviewCookie.js.map
